
import {Link} from 'react-router-dom';
import React from "react";

function Header() {
  const navRef = React.useRef(null);
  const navRef2 = React.useRef(null);
  
  const onAddClick = (e) => {
    navRef.current.classList.add("active");
    navRef2.current.classList.add("active");
  };
  const onRemoveClick = (e) => {
    navRef.current.classList.remove("active");
    navRef2.current.classList.remove("active");
  };

    return (
        <>

 
<div className="off_canvars_overlay" ref={navRef2} onClick={onRemoveClick}></div>
  <div className="offcanvas_menu">
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="offcanvas_menu_wrapper" ref={navRef}>
            <div className="canvas_close" onClick={onRemoveClick}>
            <i className="fa fa-times" aria-hidden="true"></i>

             
            </div>
         
            <div id="menu" className="text-left ">
            <div className="header-logo" style={{margin:'-30px 0px 30px 0px'}}>
                  <Link to="/">
                        <img src="assets/img/Shvetdhara-Logo.webp" alt="Seedo" /></Link>
                         <Link to="/">
                      <h3>Shvetdhara</h3>
                      
                      </Link>
                    
                    </div>
              <ul className="offcanvas_main_menu">
             
                      <li className="">
              <Link to="/">Home</Link>
              
              </li>
              <li>
              <Link to="/about">About us</Link>
              </li>
              
              <li>
              <Link to="/products">Products</Link>
              </li>
              
              <li>
              <Link to="/contact">Contact us</Link>
              </li>
                    
              </ul>
            </div>
           
          </div>
        </div>
      </div>
    </div>
  </div>



        

        <header className="ot-header header-layout1">
          <div className="header-top">
            <div className="container">
              <div className="row justify-content-center justify-content-lg-between align-items-center gy-2">
                <div className="col-auto d-none d-lg-block">
                  <div className="header-links">
                    <ul>
                    
                      <li>
                        <i className="fal fa-envelope" />
                        <a href="mailto:business@shvetdhara.com">business@shvetdhara.com</a>
                      </li>

                      <li>
                        <i className="fal fa-envelope" />
                        <a href="#">+91-98765 43210</a>
                      </li>
                    </ul>
                  </div>
                </div>
              
              </div>
            </div>
          </div>
          <div className="sticky-wrapper">
            <div className="menu-area">
              <div className="container">
                <div className="row align-items-center justify-content-between">
                  <div className="col-auto">
                    <div className="header-logo">
                      <Link to="/">
                        <img src="assets/img/Shvetdhara-Logo.webp" alt="Seedo" />
                      </Link>
                      <Link to="/">
                      <h3>Shvetdhara</h3>
                      <span>Har Din Ki Shuruaat, Shvetdhara ke Saath.</span>
                      </Link>
                    </div>
                  </div>
                  <div className="col-auto">
                    <nav className="main-menu d-none d-lg-inline-block">
                      <ul>
                      <li className="">
              <Link to="/">Home</Link>
              
              </li>
              <li>
              <Link to="/about">About us</Link>
              </li>
              
              <li>
              <Link to="/products">Products</Link>
              </li>
              
              <li>
              <Link to="/contact">Contact us</Link>
              </li>
                      </ul>
                    </nav>
                    <button
                      type="button" onClick={onAddClick}
                      className="ot-menu-toggle d-block d-lg-none"
                    >
                      <i className="far fa-bars" />
                    </button>
                  </div>
                 
                </div>
              </div>
            </div>
          </div>
        </header>
      </>
      
    );
  }
  
  export default Header;
  